import logo from 'assets/logo.svg';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { AuthImageByUserRole, IUserRole } from 'types/Auth';

import {
  Alert,
  Box,
  Card,
  CardMedia,
  Grid,
  LinearProgress,
  Paper,
  Typography,
} from '@mui/material';

type Props = {
  title: string;
  error?: string;
  loading?: boolean;
  userRole: IUserRole;
};

export const AuthTemplate: FC<Props> = ({
  title,
  loading,
  children,
  error,
  userRole,
}) => {
  const bgImage = AuthImageByUserRole[userRole];

  return (
    <Box
      style={{
        height: '90vh',
      }}
    >
      <Grid container justifyContent="center" pb={12} height="100%">
        <Grid item container xl={7} lg={8} md={10} spacing={4} py={4}>
          {/* <Grid item container xs={6} justifyContent="center">
            <Link to={userRole ? `/${userRole}` : '/'}>
              <Box component="img" alt="Vet4all logo" src={logo} py={2} />
            </Link>
          </Grid> */}

          <Grid
            item
            container
            xs={6}
            justifyContent="center"
            alignContent="center"
          >
            <Typography variant="h4">{title}</Typography>
          </Grid>
        </Grid>

        <Grid item container xl={7} lg={8} md={10} spacing={4}>
          <Grid item md={6} xs={12}>
            <Paper elevation={2} sx={{ height: '100%' }}>
              {loading && (
                <LinearProgress
                  sx={{
                    height: 6,
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                  }}
                />
              )}

              {/* 
              Show success if user registration is successfull
              <Alert variant="standard" severity="success">
                This is a success alert — check it out!
              </Alert> */}

              {error && (
                <Alert variant="outlined" severity="error">
                  {error}
                </Alert>
              )}

              {children}
            </Paper>
          </Grid>

          <Grid item md={6} xs={12}>
            <Card sx={{ borderRadius: 4, height: '100%' }}>
              <CardMedia
                component="img"
                height="100%"
                image={bgImage}
                alt="Vet4all"
              />
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
